import Controller from "@ember/controller";
import { task, dropTask } from "ember-concurrency";
import { service } from "@ember/service";
import destroyRecord from "glesys-controlpanel/utils/destroy-record";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class EmailDomainDetailsController extends Controller {
  @service store;

  get domain() {
    return this.model.domain;
  }

  usedQuota(usedQouta) {
    return typeof usedQouta === "undefined" ? "-" : usedQouta;
  }

  createAccountTask = dropTask(async (prefix) => {
    let domain = this.domain;
    let emailaccount = `${prefix}@${domain.get("domainname")}`;

    let account = this.store.createRecord("email-account", {
      domain,
      emailaccount,
      usedQuota: 0,
    });

    return await this.store
      .request(saveRecord(account))
      .then(({ content }) => content)
      .catch((reason) => {
        account.unloadRecord();
        throw reason;
      });
  });

  createAliasTask = task(async (prefix, goto) => {
    let domain = this.domain;
    let emailalias = `${prefix}@${domain.get("domainname")}`;

    let alias = this.store.createRecord("email-alias", {
      domain,
      emailalias,
      goto,
    });

    await this.store.request(saveRecord(alias)).catch((reason) => {
      alias.unloadRecord();
      throw reason;
    });
  });

  deleteAliasTask = task(async (alias) => {
    await destroyRecord(alias);
  });

  updateAliasTask = task(async (alias) => {
    return this.store
      .request(saveRecord(alias))
      .then(({ content }) => content)
      .catch((error) => {
        alias.rollbackAttributes();
        throw error;
      });
  });
}
